/**
 * Libraries provided by TAL to consuming apps.
 */

import "@babel/polyfill";

window["React"] = require("react");
window["ReactDOM"] = require("react-dom");
window["styled"] = require("styled-components");
